import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';

class GeospatialHeatmapVisualizer extends Component {
  getMapOptions = maps => ({
    mapTypeControl: true,
    mapTypeId: maps.MapTypeId.SATELLITE,
  })

 mapHeatmapPoint = d => ({ lat: d.latitude, lng: d.longitude, weight: d.events })

 render() {
   const { data, options } = this.props;

   const heatMapData = data[0].data.map(this.mapHeatmapPoint);
   const highestWeight = heatMapData.length > 0 ? heatMapData.sort((a, b) => b.weight - a.weight)[0].weight : 100;

   return (
     <div style={{ height: '75vh', width: '100%' }}>
       <GoogleMapReact
         options={this.getMapOptions}
         bootstrapURLKeys={{ key: options.apiKey }}
         defaultCenter={{ lat: options.center.latitude, lng: options.center.longitude }}
         defaultZoom={15}
         heatmapLibrary
         heatmap={{ positions: heatMapData, options: { maxIntensity: highestWeight * 0.5 } }}
       />
     </div>
   );
 }
}

GeospatialHeatmapVisualizer.propTypes = {
  data: PropTypes.array,
  options: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
};

GeospatialHeatmapVisualizer.defaultProps = {
  data: [],
  options: [],
};

export default GeospatialHeatmapVisualizer;
